import { useT } from "@/lib/i18n"
import { Check, Copy } from "lucide-react"
import { useEffect, useState } from "react"
import { cn } from "@/lib/utils"

export function CopyButton({ value, label, className }: { value: string; label?: string; className?: string }) {
  const t = useT()
  const [copied, setCopied] = useState(false)
  useEffect(() => {
    if (!copied) return
    const id = setTimeout(() => setCopied(false), 1400)
    return () => clearTimeout(id)
  }, [copied])
  return (
    <button
      type="button"
      aria-label={copied ? t("copy.copied") : (label ?? t("copy.label"))}
      title={copied ? t("copy.copied") : (label ?? t("copy.label"))}
      onClick={() => {
        void navigator.clipboard.writeText(value).then(() => setCopied(true))
      }}
      className={cn("inline-flex size-6 items-center justify-center rounded-sm text-subtle-foreground transition-colors duration-150 hover:bg-raised hover:text-foreground", className)}
    >
      {copied ? <Check className="size-3.5 text-success" /> : <Copy className="size-3.5" />}
    </button>
  )
}

/** A monospace identifier with a copy affordance: artifact ids, hashes, keys. */
export function Mono({ value, display, className, copy = true }: { value: string; display?: string; className?: string; copy?: boolean }) {
  const t = useT()
  return (
    <span className={cn("inline-flex min-w-0 items-center gap-0.5", className)}>
      <code className="truncate font-mono text-xs text-foreground/90" title={value}>
        {display ?? value}
      </code>
      {copy ? <CopyButton value={value} label={t("copy.value", { value })} /> : null}
    </span>
  )
}
